import { useDispatch } from "react-redux";
import { amApi } from "../../api/apiHelper";
import { SET_VENDORACCESS, CLEAR_VENDORACCESS } from "../types";
import {
  create_and_update_restaurant,
  get_new_subscription_for_vendor,
  // redirectUrlSave,
} from "./authAction";

export const setVendorAccess = (id, onSuccess) => async (dispatch) => {
  let url = window.location.pathname;
  try {
    let vendorAccess = await amApi.post(`/vendorAccess`, { vendor_id: id });
    if (vendorAccess.status === 201) {
      dispatch({
        type: SET_VENDORACCESS,
        payload: { id: id, redirect_back_url: url },
      });
      onSuccess();
    }
  } catch (err) {
    console.log("Set Vendor Access", err);
  }
};

export const clearVendorAccess = () => async (dispatch) => {
  try {
    dispatch({
      type: CLEAR_VENDORACCESS,
    });
  } catch (err) {
    console.log(err);
  }
};

export const vendorDashboardfromAdmin =
  (id, onViewDashboard) => async (dispatch) => {
    dispatch(create_and_update_restaurant({ vendor_id: id }));
    dispatch(get_new_subscription_for_vendor({ vendor_id: id }));
    dispatch(setVendorAccess(id, onViewDashboard));
  };
